import { Divider } from "@mui/material";
import clsx from "clsx";
import { useIntl } from "react-intl";

import { CollapsibleCard } from "@/components/CollapsibleCard/CollapsibleCard";

type TripTourPlanProps = {
  itineraries: string[];
};

export function TripTourPlan({ itineraries }: TripTourPlanProps) {
  const intl = useIntl();

  return (
    <ol className="ps-6">
      {itineraries.map((itinerary, index) => (
        <li
          key={index}
          className={clsx(
            "relative",
            "before:absolute before:-start-4.75 before:top-5 before:h-[calc(100%-var(--spacing)*2)] before:w-[1.5px] before:bg-stroke-neutral-soft",
            "last:before:hidden",
          )}
        >
          <div
            className={clsx(
              "relative mb-2 text-sm font-bold text-text-primary",
              "before:bg-primary before:absolute before:-start-7 before:top-0 before:box-content before:size-3 before:rounded-full before:border-4 before:border-white before:bg-surface-accent-soft",
              "after:absolute after:-start-5.25 after:top-1.75 after:box-content after:size-1.5 after:rounded-full after:bg-core-accent-500",
            )}
          >
            {intl.formatMessage({ id: "trips.dayNumber" }, { day: index + 1 })}
          </div>

          <div className="text-sm text-text-primary">
            <ol className="list-disc space-y-1 ps-4 marker:text-[10px] marker:text-[#D9D9D9]">
              {itinerary
                .split("\n")
                .filter((item) => item.trim() !== "")
                .map((item) => (
                  <li key={item}>{item}</li>
                ))}
            </ol>
          </div>

          {index < itineraries.length - 1 && (
            <Divider
              sx={{
                borderColor: "#F4F3F5",
                my: "calc(var(--spacing)*3)",
              }}
            />
          )}
        </li>
      ))}
    </ol>
  );
}

type TripTourPlanCardProps = {
  itineraries: string[];
};

export function TripTourPlanCard({ itineraries }: TripTourPlanCardProps) {
  const intl = useIntl();

  return (
    <CollapsibleCard
      title={intl.formatMessage({ id: "trips.tripPlan.title" })}
      subtitle={intl.formatMessage({ id: "trips.tripPlan.subtitle" })}
    >
      <TripTourPlan itineraries={itineraries} />
    </CollapsibleCard>
  );
}
